export enum LOCAL_STORAGE_KEYS {
  USER_DATA = '@TOP_RUNNING/USER_DATA',
  STUDENT_TRAININGS_LIST_VIEW_TYPE = '@TOP_RUNNING/ST_LIST_VIEW_TYPE',
}
